import { Component, OnInit, NgZone, Input } from '@angular/core';
import { FADE_IN_LEFT_BIG, FADE_IN_RIGHT_BIG } from '../../animations/fade-in.animation';
import { MatDialog } from '@angular/material/dialog';
import { CreateAccountComponent } from '../create-account/create-account.component';

interface Testimonial {
  title: string;
  quote: string;
  signature: string;
}

@Component({
  selector: 's18-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss'],
  animations: [FADE_IN_LEFT_BIG, FADE_IN_RIGHT_BIG]
})
export class TestimonialsComponent implements OnInit {
  @Input() animate: boolean = false;

  carouselBanner: any;
  testimonials: Testimonial[] = [
    {
      title: 'Best out there !!',
      quote: '"... the features along with the online benefits are excellent. Would highly recommend this software for any individual, league, or tournament use. The betting action feature is great to ensure you collect from your friends before they leave! Keep up the good work! "',
      signature: 'Ken L.'
    },
    {
      title: 'Very Nice !!',
      quote: '"... Know where you stand in real time."',
      signature: 'Mark R.'
    },
    {
      title: 'Great App!!',
      quote: '"This is a great App for keeping up to date live scoring in any golf tournament."',
      signature: 'Kevin M.'
    },
    {
      title: 'Software was exceptional!',
      quote: '"... we are once again looking forward to having your software make scoring on our trip a breeze! "',
      signature: 'The WAB Crew'
    }
  ];

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.carouselBanner = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 500,
      interval: { timing: 3000 },
      point: {
        visible: true
      },
      load: 2,
      loop: true,
      touch: true
    };
  }

  animationStatus() {
    if (this.animate) {
      return 'on';
    }
    return 'off';
  }

  startNow() {
    this.dialog.open(CreateAccountComponent, { width: '500px' })
  }

}
